import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_RequestForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_RequestForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h4>OUTPATIENT TREATMENT REQUEST FORM </h4></p>
                <p className='w-750'><h3>Member Information: </h3></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Diagnosis ICD-10 Code: </span>
                            <input type='text' name='txtPrimaryDiagnosis' id='txtPrimaryDiagnosis' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Co-morbid Medical Diagnosis ICD-10 Code: </span>
                            <input type='text' name='txtMedicalDiagnosis' id='txtMedicalDiagnosis' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional: </span>
                    <textarea id='txtAdditional' name='txtAdditional' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has contact occurred with PCP? </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbYes' name='rbContactOccured' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo' name='rbContactOccured' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does member participate in medical management? </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbYes1' name='rbMedicalManagement' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo1' name='rbMedicalManagement' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Behavioral Health Medications: </span>
                    <textarea id='txtHealthMedications' name='txtHealthMedications' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Conditions:  </span>
                    <textarea id='txtMedicalConditions' name='txtMedicalConditions' className='add-only'></textarea>
                </p>
                <p className='w-750'><h3> REQUESTED AUTHORIZATION </h3></p>
                <p className='w-750'>
                    <span className='small'>(please mark appropriate code(s) in the left column) </span>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>PLEASE CHECK THE CODES.</span>
                            <input type='checkbox' name='cbCodes' id='cbCodes' className='add-only' value='PleaseCheckTheCodes' />
                            Community Psychiatric Supportive Treatment
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek' id='txtVisitsPerWeek' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate' id='txtStartDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate' id='txtEndDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired' id='txtUnitsRequired' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes1' id='cbCodes1' className='add-only' value='PleaseCheckTheCodes' />
                            H0036 HK Homebuilders
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek1' id='txtVisitsPerWeek1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate1' id='txtStartDate1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate1' id='txtEndDate1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired1' id='txtUnitsRequired1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes2' id='cbCodes2' className='add-only' value='PleaseCheckTheCodes' />
                            H0036 HE Functional Family Therapy
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek2' id='txtVisitsPerWeek2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate2' id='txtStartDate2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate2' id='txtEndDate2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired2' id='txtUnitsRequired2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes3' id='cbCodes3' className='add-only' value='PleaseCheckTheCodes' />
                            H0036 HE Functional Family Therapy Child Welfare (FFT-CW)
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek3' id='txtVisitsPerWeek3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate3' id='txtStartDate3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate3' id='txtEndDate3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired3' id='txtUnitsRequired3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes4' id='cbCodes4' className='add-only' value='PleaseCheckTheCodes' />
                            Assertive Community Treatment Program (ACT) H0039
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek4' id='txtVisitsPerWeek4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate4' id='txtStartDate4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate4' id='txtEndDate4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired4' id='txtUnitsRequired4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes5' id='cbCodes5' className='add-only' value='PleaseCheckTheCodes' />
                            Multisystemic Family Therapy H2033
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek5' id='txtVisitsPerWeek5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate5' id='txtStartDate5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate5' id='txtEndDate5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired5' id='txtUnitsRequired5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes6' id='cbCodes6' className='add-only' value='PleaseCheckTheCodes' />
                            Crisis Intervention Follow Up H2011
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek6' id='txtVisitsPerWeek6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate6' id='txtStartDate6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate6' id='txtEndDate6' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired6' id='txtUnitsRequired6' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3> PRIOR AUTHORIZATION FOR PSYCHOTHERAPY CODES </h3></p>
                <p className='w-750'>
                    <span className='small'>(to be used AFTER Member has used 24 sessions that do not require a PA) </span>
                </p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>PLEASE CHECK THE CODES.</span>
                            <input type='checkbox' name='cbCodes7' id='cbCodes7' className='add-only' value='PleaseCheckTheCodes' />
                            90832 Psychotherapy 30 min. with patient and/or family member
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek7' id='txtVisitsPerWeek7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate7' id='txtStartDate7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate7' id='txtEndDate7' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired7' id='txtUnitsRequired7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes8' id='cbCodes8' className='add-only' value='PleaseCheckTheCodes' />
                            90833* Psychotherapy 30 min. with patient with patient and/or familymember when performed with an E/M service
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek8' id='txtVisitsPerWeek8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate8' id='txtStartDate8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate8' id='txtEndDate8' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired8' id='txtUnitsRequired8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes9' id='cbCodes9' className='add-only' value='PleaseCheckTheCodes' />
                            90834 Psychotherapy 45 min. with patient and/or family member
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek9' id='txtVisitsPerWeek9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate9' id='txtStartDate9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate9' id='txtEndDate9' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired9' id='txtUnitsRequired9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes10' id='cbCodes10' className='add-only' value='PleaseCheckTheCodes' />
                            90836* Psychotherapy 45 min. with patient and/or family member when performed with an E/M service
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek10' id='txtVisitsPerWeek10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate10' id='txtStartDate10' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate10' id='txtEndDate10' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired10' id='txtUnitsRequired10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes11' id='cbCodes11' className='add-only' value='PleaseCheckTheCodes' />
                            90837 Psychotherapy 60 min. with patient and/or family  member
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek11' id='txtVisitsPerWeek11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate11' id='txtStartDate11' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate11' id='txtEndDate11' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired11' id='txtUnitsRequired11' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes12' id='cbCodes12' className='add-only' value='PleaseCheckTheCodes' />
                            90838* Psychotherapy 60 min. with patient and/or family member when performed with E/M service
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek12' id='txtVisitsPerWeek12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate12' id='txtStartDate12' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate12' id='txtEndDate12' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired12' id='txtUnitsRequired12' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes13' id='cbCodes13' className='add-only' value='PleaseCheckTheCodes' />
                            90840 Psychotherapy for Crisis each additional 30 min
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek13' id='txtVisitsPerWeek13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate13' id='txtStartDate13' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate13' id='txtEndDate13' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired13' id='txtUnitsRequired13' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes14' id='cbCodes14' className='add-only' value='PleaseCheckTheCodes' />
                            90847 Family Psychotherapy conjoint psychotherapy; with patient present
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek14' id='txtVisitsPerWeek14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate14' id='txtStartDate14' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate14' id='txtEndDate14' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired14' id='txtUnitsRequired14' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes15' id='cbCodes15' className='add-only' value='PleaseCheckTheCodes' />
                            90849 Multiple Family Group  Psychotherapy
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek15' id='txtVisitsPerWeek15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate15' id='txtStartDate15' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate15' id='txtEndDate15' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired15' id='txtUnitsRequired15' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes16' id='cbCodes16' className='add-only' value='PleaseCheckTheCodes' />
                            90853 Group Psychotherapy other than of a multiple family group
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek16' id='txtVisitsPerWeek16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate16' id='txtStartDate16' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate16' id='txtEndDate16' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired16' id='txtUnitsRequired16' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes17' id='cbCodes17' className='add-only' value='PleaseCheckTheCodes' />
                            90845 Psychoanalysis
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek17' id='txtVisitsPerWeek17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate17' id='txtStartDate17' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate17' id='txtEndDate17' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired17' id='txtUnitsRequired17' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes18' id='cbCodes18' className='add-only' value='PleaseCheckTheCodes' />
                            90875 Individual Therapy with Biofeedback 30 min.
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsPerWeek18' id='txtVisitsPerWeek18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate18' id='txtStartDate18' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate18' id='txtEndDate18' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired18' id='txtUnitsRequired18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='cbCodes19' id='cbCodes19' className='add-only' value='PleaseCheckTheCodes' />
                            90876 Individual Therapy with Biofeedback 60 min
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'># of Visits per Week </span>
                            <input type='text' name='txtVisitsperWeek19' id='txtVisitsPerWeek19' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested Start Date </span>
                            <input type='date' name='txtStartDate19' id='txtStartDate19' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Requested End Date </span>
                            <input type='date' name='txtEndDate19' id='txtEndDate19' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Total # of Units Required </span>
                            <input type='text' name='txtUnitsRequired19' id='txtUnitsRequired19' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3> FUNCTIONAL OUTCOMES </h3></p>
                <p className='w-750'>
                    <span className='small'>(Choose yes or no) </span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>1.In the last 30 days, has member been in crisis? </span>
                    <input type='radio' id='rbYes2' name='rbLast30Days' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo2' name='rbLast30Days' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2.In the last 30 days, has member received inpatient or residential behavioral health care?  </span>
                    <input type='radio' id='rbYes3' name='rbResidentialBehaviour' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo3' name='rbResidentialBehaviour' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3.In the last 30 days, has the member had problems with sleeping or feeling sad? </span>
                    <input type='radio' id='rbYes4' name='rbFeelingSad' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo4' name='rbFeelingSad' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4.In the last 30 days, has the member had problems with had problems with fears and anxiety? </span>
                    <input type='radio' id='rbYes5' name='rbAnxiety' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo5' name='rbAnxiety' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5.In the last 30 days, has alcohol or drug use caused problems for member?  </span>
                    <input type='radio' id='rbYes6' name='rbCausedProblems' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo6' name='rbCausedProblems' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6.In the last 30 days, has member gotten in trouble with the law? </span>
                    <input type='radio' id='rbYes7' name='rbGottenInTrouble' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo7' name='rbCausedProblems' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7.In the last 30 days, has member had trouble getting along with other people including
                        family and people out the home?
                    </span>
                    <input type='radio' id='rbYes8' name='rbIncludingFamily' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo8' name='rbIncludingFamily' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>8.In the last 30 days, has member had an unstable living situation?
                    </span>
                    <input type='radio' id='rbYes9' name='rbLivingSituation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo9' name='rbLivingSituation' className='add-only' value='No' /> No
                </p>
                <p className='w-750'><h3>CHILDREN ONLY </h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>9. In the last 30 days, has member been suspended or expelled from school? </span>
                    <input type='radio' id='rbYes10' name='rbExpelledFromSchool' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo10' name='rbExpelledFromSchool' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>10. Is member currently in state custody (DCFS or Juvenile Justice)?  </span>
                    <input type='radio' id='rbYes11' name='rbStateCustody' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo11' name='rbStateCustody' className='add-only' value='No' /> No
                </p>
                <p className='w-750'><h3>ADULTS ONLY </h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>11. Is member currently employed or attending school?  </span>
                    <input type='radio' id='rbYes12' name='rbAttendingSchool' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo12' name='rbAttendingSchool' className='add-only' value='No' /> No
                </p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SYMPTOMS  </span>
                            <span className='small'>(IF PRESENT , SELECT DEGREE TO WHICH IT IMPACTS DAILY FUNCTIONING.)</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>N/A </span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Mild </span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Moderate </span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Severe </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Anxiety/Panic Attacks
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbAnxiety' id='cbAnxiety' className='add-only' value='Anxiety' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbAnxiety1' id='cbAnxiety1' className='add-only' value='Anxiety' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbAnxiety2' id='cbAnxiety2' className='add-only' value='Anxiety' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbAnxiety3' id='cbAnxiety3' className='add-only' value='Anxiety' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Decreased Energy
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDecreasedEnergy' id='cbDecreasedEnergy' className='add-only' value='DecreasedEnergy' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDecreasedEnergy1' id='cbDecreasedEnergy1' className='add-only' value='DecreasedEnergy' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDecreasedEnergy2' id='cbDecreasedEnergy2' className='add-only' value='DecreasedEnergy' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDecreasedEnergy3' id='cbDecreasedEnergy3' className='add-only' value='DecreasedEnergy' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Depressed Mood
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDepressedMood' id='cbDepressedMood' className='add-only' value='DepressedMood' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDepressedMood1' id='cbDepressedMood1' className='add-only' value='DepressedMood' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDepressedMood2' id='cbDepressedMood2' className='add-only' value='DepressedMood' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbDepressedMood3' id='cbDepressedMood3' className='add-only' value='DepressedMood' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Hopelessness
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHopelessness' id='cbHopelessness' className='add-only' value='Hopelessness' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHopelessness1' id='cbHopelessness1' className='add-only' value='Hopelessness' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHopelessness2' id='cbHopelessness2' className='add-only' value='Hopelessness' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHopelessness3' id='cbHopelessness3' className='add-only' value='Hopelessness' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Social Withdrawal
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSocialWithdrawal' id='cbSocialWithdrawal' className='add-only' value='SocialWithdrawal' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSocialWithdrawal1' id='cbSocialWithdrawal1' className='add-only' value='SocialWithdrawal' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSocialWithdrawal2' id='cbSocialWithdrawal2' className='add-only' value='SocialWithdrawal' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSocialWithdrawal3' id='cbSocialWithdrawal3' className='add-only' value='SocialWithdrawal' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Hyperactivity
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHyperactivity' id='cbHyperactivity' className='add-only' value='Hyperactivity' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHyperactivity1' id='cbHyperactivity1' className='add-only' value='Hyperactivity' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHyperactivity2' id='cbHyperactivity2' className='add-only' value='Hyperactivity' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbHyperactivity3' id='cbHyperactivity3' className='add-only' value='Hyperactivity' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Inattention
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbInattention' id='cbInattention' className='add-only' value='Inattention' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbInattention1' id='cbInattention1' className='add-only' value='Inattention' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbInattention2' id='cbInattention2' className='add-only' value='Inattention' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbInattention3' id='cbInattention3' className='add-only' value='Inattention' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Impulsivity
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbImpulsivity' id='cbImpulsivity' className='add-only' value='Impulsivity' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbImpulsivity1' id='cbImpulsivity1' className='add-only' value='Impulsivity' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbImpulsivity2' id='cbImpulsivity2' className='add-only' value='Impulsivity' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbImpulsivity3' id='cbImpulsivity3' className='add-only' value='Impulsivity' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Mood Swings
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMoodSwings' id='cbMoodSwings' className='add-only' value='MoodSwings' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMoodSwings1' id='cbMoodSwings1' className='add-only' value='MoodSwings' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMoodSwings2' id='cbMoodSwings2' className='add-only' value='MoodSwings' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMoodSwings3' id='cbMoodSwings3' className='add-only' value='MoodSwings' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Outbursts/Anger
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbOutburstsAnger' id='cbOutburstsAnger' className='add-only' value='OutburstsAnger' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbOutburstsAnger1' id='cbOutburstsAnger1' className='add-only' value='OutburstsAnger' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbOutburstsAnger2' id='cbOutburstsAnger2' className='add-only' value='OutburstsAnger' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbOutburstsAnger3' id='cbOutburstsAnger3' className='add-only' value='OutburstsAnger' />
                        </td></center>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>FUNCTIONAL IMPAIRMENT  </span>
                            <span className='small'>(IF PRESENT, SELECT DEGREE TO WHICH IT IMPACTS DAILY FUNCTIONING.) </span>
                        </td>
                        <center><td className='w-125'>
                            <span className='eleHeader'>N/A </span>
                        </td></center>
                        <center><td className='w-125'>
                            <span className='eleHeader'>Mild </span>
                        </td></center>
                        <center><td className='w-125'>
                            <span className='eleHeader'>Moderate </span>
                        </td></center>
                        <center><td className='w-125'>
                            <span className='eleHeader'>Severe </span>
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Personal Hygiene
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPersonalHygiene' id='cbPersonalHygiene' className='add-only' value='PersonalHygiene' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPersonalHygiene1' id='cbPersonalHygiene1' className='add-only' value='PersonalHygiene' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPersonalHygiene2' id='cbPersonalHygiene2' className='add-only' value='PersonalHygiene' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPersonalHygiene3' id='cbPersonalHygiene3' className='add-only' value='PersonalHygiene' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Sleep
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSleep' id='cbSleep' className='add-only' value='Sleep' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSleep1' id='cbSleep1' className='add-only' value='Sleep' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSleep2' id='cbSleep2' className='add-only' value='Sleep' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSleep3' id='cbSleep3' className='add-only' value='Sleep' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Medication Compliance
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMedicationCompliance' id='cbMedicationCompliance' className='add-only' value='MedicationCompliance' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMedicationCompliance1' id='cbMedicationCompliance1' className='add-only' value='MedicationCompliance' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMedicationCompliance2' id='cbMedicationCompliance2' className='add-only' value='MedicationCompliance' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbMedicationCompliance3' id='cbMedicationCompliance3' className='add-only' value='MedicationCompliance' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Substance Use (Current)
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSubstanceUse' id='cbSubstanceUse' className='add-only' value='SubstanceUseCurrent' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSubstanceUse1' id='cbSubstanceUse1' className='add-only' value='SubstanceUseCurrent' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSubstanceUse2' id='cbSubstanceUse2' className='add-only' value='SubstanceUseCurrent' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbSubstanceUse3' id='cbSubstanceUse3' className='add-only' value='SubstanceUseCurrent' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Physical Health
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPhysicalHealth' id='cbPhysicalHealth' className='add-only' value='PhysicalHealth' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPhysicalHealth1' id='cbPhysicalHealth1' className='add-only' value='PhysicalHealth' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPhysicalHealth2' id='cbPhysicalHealth2' className='add-only' value='PhysicalHealth' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbPhysicalHealth3' id='cbPhysicalHealth3' className='add-only' value='PhysicalHealth' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Work/School
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbWorkSchool' id='cbWorkSchool' className='add-only' value='WorkSchool' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbWorkSchool1' id='cbWorkSchool1' className='add-only' value='WorkSchool' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbWorkSchool2' id='cbWorkSchool2' className='add-only' value='WorkSchool' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbWorkSchool3' id='cbWorkSchool3' className='add-only' value='WorkSchool' />
                        </td></center>
                    </tr>
                    <tr>
                        <td className='w-250'>Relationships
                        </td>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbRelationships' id='cbRelationships' className='add-only' value='Relationships' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbRelationships1' id='cbRelationships1' className='add-only' value='Relationships' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbRelationships2' id='cbRelationships2' className='add-only' value='Relationships' />
                        </td></center>
                        <center><td className='w-125'>
                            <input type='checkbox' name='cbRelationships3' id='cbRelationships3' className='add-only' value='Relationships' />
                        </td></center>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List Substance Used:  </span>
                    <textarea id='txtSubstanceUsed' name='txtSubstanceUsed' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>CURRENT RISK ASSESSMENT  </span>
                </p>
                <p className='w-750'>
                    <span className='small'>(select all that apply) </span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Suicidal:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' name='cbNone' id='cbNone' className='add-only' value='None' />
                            None
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbIdeation' id='cbIdeation' className='add-only' value='Ideation' />
                            Ideaation
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbPlanned' id='cbPlanned' className='add-only' value='Planned' />
                            Planned
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbImminentIntent' id='cbImminentIntent' className='add-only' value='ImminentIntent' />
                            Imminent Intent
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbSelfInjury' id='cbSelfInjury' className='add-only' value='SelfInjury' />
                            Self Injury
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Homicidal:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' name='cbNone1' id='cbNone1' className='add-only' value='None' />
                            None
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbIdeation1' id='cbIdeation1' className='add-only' value='Ideation' />
                            Ideation
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbPlanned1' id='cbPlanned1' className='add-only' value='Planned' />
                            Planned
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbImminentIntent1' id='cbImminentIntent1' className='add-only' value='ImminentIntent' />
                            Imminent Intent
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' name='cbInjuryToOthers' id='cbInjuryToOthers' className='add-only' value='InjuryOthers' />
                            Injury to others
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>History of harm to others (dates) </span>
                    <textarea id='txtHistory' name='txtHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>History of self-harming behavior (dates) </span>
                    <textarea id='txtHistory1' name='txtHistory1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Safety Plan in place? </span>
                    <span className='small'>(If plan or intent indicated attach recent crisis plan) </span>
                </p>
                <p className='w-750'>
                    <input type='radio' id='rbYes13' name='rbSafetyPlan' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNo13' name='rbSafetyPlan' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any recent crisis: </span>
                    <textarea id='txtRecentCrises' name='txtRecentCrises' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Goal 1: </span>
                    <textarea id='txtGoal1' name='txtGoal1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Specific Progress Made: </span>
                    <textarea id='txtProgressMade' name='txtProgressMade' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Continued Barriers to Goal Attainment: </span>
                    <textarea id='txtcontinuedBarriers' name='txtContinuedBarriers' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Goal 2: </span>
                    <textarea id='txtGoal2' name='txtGoal2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Specific Progress Made: </span>
                    <textarea id='txtProgressMade1' name='txtProgressMade1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Continued Barriers to Goal Attainment: </span>
                    <textarea id='txtcontinuedBarriers1' name='txtContinuedBarriers1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Goal 3: </span>
                    <textarea id='txtGoal3' name='txtGoal3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Specific Progress Made: </span>
                    <textarea id='txtProgressMade2' name='txtProgressMade2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Continued Barriers to Goal Attainment: </span>
                    <textarea id='txtcontinuedBarriers2' name='txtContinuedBarriers2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Goal 4: </span>
                    <textarea id='txtGoal4' name='txtGoal4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Specific Progress Made: </span>
                    <textarea id='txtProgressMade3' name='txtProgressMade3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'> Continued Barriers to Goal Attainment: </span>
                    <textarea id='txtcontinuedBarriers3' name='txtContinuedBarriers3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe presenting problems. </span>
                    <textarea id='txtPresentingProblems' name='txtPresentingProblems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If this is a re-authorization, please provide a brief narrative expressing the success or lack of
                        success during the previous authorization period.
                    </span>
                    <textarea id='txtPreviousAuthorization' name='txtPreviousAuthorization' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe what worked for the member, what did not work for the member, and how member's
                        symptoms specifically continue to impair functioning.
                    </span>
                    <textarea id='txtImpairFunctioning' name='txtImpairFunctioning' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Please feel free to attach additional documentation to support your request (e.g. updated treatment
                    plan, progress notes, etc.).
                </p>


                <table>
                    <tr>
                        <td className='signature w-600'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Clinician printed name with Credentials</td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-600'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Clinician Signature with Credentials</td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











